import Room from '@/models/Room';

export default class SpecialRoom extends Room {
  constructor({
    x, y, width, height, type, groupManager,
  }) {
    super({
      x, y, width, height, type, groupManager,
    });
    this.bookList = Array.from({ length: this.maxCapacity });
  }

  get memberCount() {
    return this.bookList.filter((m) => m).length;
  }

  get hasEmptySeat() {
    return this.bookList.filter((m) => !m).length > 0;
  }

  bookSeat(member) {
    if (!this.hasEmptySeat) {
      return undefined;
    }
    const index = this.bookList.findIndex((m) => !m);
    this.bookList[index] = member;
    return this.getCoordInRoom(index);
  }

  leave(member) {
    const index = this.bookList.findIndex((m) => m === member);
    this.bookList[index] = undefined;
  }
}
